'use client';

import { styled } from '@mui/material/styles';

import { HEADER_DESKTOP_HEIGHT, HEADER_MOBILE_HEIGHT } from './config';

export const HeaderHeightPadding = styled( 'div' )(({ theme }) => ({
  paddingTop: HEADER_MOBILE_HEIGHT,
  [theme.breakpoints.up( 'md' )]: { paddingTop: HEADER_DESKTOP_HEIGHT },
}));
